import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Cover, FAQs, Image, Input, Layout, Link, SEO, SectionReviewModals } from 'components';
import { routes } from 'utils/routes';
import { cta } from 'utils/cta';
import { media } from "utils/media";

// Content
import contentSEO from "cms/content/shipping-seo.yml";
import contentCover from "cms/content/shipping-cover.yml";
import contentForm from "cms/content/shipping-section-form.yml";
import contentFlags from "cms/content/shipping-section-flags.yml";
import contentSecReviewModals from "cms/content/shipping-section-review-modals.yml"
import contentFaqs from "cms/content/shipping-faqs.yml"

const formFeedback = [
  contentForm.sending,
  contentForm.success,
  contentForm.error,
];

const ShippingPage = ({ pageContext: { locale }, location }) => {
  const [formStatus, handleFormStatus] = useState(-1);
  const [formError, handleFormError] = useState(null);
  const sending = () => handleFormStatus(0);
  const success = () => handleFormStatus(1);
  const failed = () => handleFormStatus(2);

  const handleSubmit = (ev) => {
    ev.preventDefault();
    handleFormError(null);
    sending();
    // todo: update url
    const url = 'https://www.straightteethdirect.com/wp-json/contact-form-7/v1/contact-forms/1149/feedback';
    const data = new FormData(ev.target);

    fetch(url, {
      method: 'POST',
      body: data,
      credentials: "same-origin",
    }).then(function(response) {
      // response.status     //=> number 100–599
      // response.statusText //=> String
      // response.headers    //=> Headers
      // response.url        //=> String
      success();
      // return response.text();
    }, function(error) {
      failed();
      handleFormError(error.message);
    });
  };

  return (
    <Layout locale={locale}>
      <SEO
        title={contentSEO.title}
        description={contentSEO.description}
        lang={locale}
        keywords={contentSEO.keywords}
        location={location}
        image={contentSEO.socialImage}
      />

      <Cover
        title={contentCover.title}
        image={{ url: media(contentCover.image), alt: 'Free global shipping' }}
        button={{ label: cta.getStarted, ...routes.getStarted }}
        overlap={contentCover.overlap}
        trustpilot={contentCover.trustpilot}
      />

      <h3 className='section-title'>{contentFlags.title}</h3>
      <p className='mt-10 mb-40 t-center'>{contentFlags.subtitle}</p>

      <div className='section-shipping'>
        <h3 className='section-title'>{contentFlags.tagline}</h3>
        <div className='flex-wrap'>
          {contentFlags.flagSections.map(({ flags }) => (
            <div className='flags-wrapper'>
              {flags.map(({ icon, caption }) => (
                <Image url={media(icon)} alt={caption} caption={caption} />
              ))}
            </div>
          ))}
        </div>

        <h3 className='section-title mb-50 mt-90' dangerouslySetInnerHTML={{ __html: contentForm.title }} />
        <form onSubmit={handleSubmit} className='form-wrapper'>
          <Input id='state' name='Yourcity' placeholder='Your state *' required/>
          <Input id='email' name='Youremail' placeholder='Your email *' type='email' required />
          <Input id='country' name='Yourcountry' placeholder='Country request *' required />
          {formStatus > -1 &&
            <p className='ml-20 mr-20'>
              <b>
                {formFeedback[formStatus]}
                {formError && <span className='block red'><br/>{formError}</span>}
              </b>
            </p>
          }
          <div className='shipping-actions'>
            <Button label={contentForm.submitText} level='outline' />
            <p>{contentForm.ctaText} <Link to={routes.dentists.path} {...routes.dentists}>{contentForm.ctaLinkText}</Link></p>
          </div>
        </form>
      </div>

      {contentFaqs.enabled && <FAQs title='Shipping FAQs' faqsData={contentFaqs['faqs']} className='mb-50 mt-90'  locale={locale} />}

      <SectionReviewModals content={contentSecReviewModals} />

    </Layout>
  );
};

ShippingPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default ShippingPage;
